<template>
 	<div class="flex-colum h-100">
		<div class="d-flex justify-content-between bd-highlight mb-3">
			<div class="align-self-center mb-3" style="height: 30px;">
				<button type="button" class="btn btn-primary" @click="openAddLabelDialog">添加</button>
			</div>
		</div>
		<div>
			<table class="table table-bordered table-striped table-sm member-list">
				<thead>
					<tr>
						<th scope="col">序号</th><th scope="col">标题</th><th scope="col">ID</th><th scope="col">状态</th><th scope="col">添加时间</th><th scope="col">操作</th>
					</tr>
				</thead>
				<tbody id="member-list">
					<tr v-for="(value, idx) in dataList" :key='idx'>
						<td>{{50 * (nowPage - 1) + idx + 1}}</td>
						<td>{{value.title}}</td>
						<td>{{value.id}}</td>
						<td>
							<div class="mb-1 form-check form-switch" style="padding-top: 5px;">
								<input class="form-check-input" checked type="checkbox" role="switch" v-if="value.show === 1"/>
								<input class="form-check-input" type="checkbox" role="switch" v-else/>
							</div>
						</td>
						<td>{{dateFtt('yyyy-MM-dd hh:mm', new Date(value.operateTime))}}</td>
						<td>
							<div class="flex-row flex-align-center">
								<img class="button-icon" src="/assets/ic_edit.png" @click="openEditLabelDialog(value.id)"/>
								<img class="button-icon img-margin" src="/assets/ic_trash.png" @click="deleteLabel(value.id, value.title)"/>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
			<Pagination :page='nowPage' :max='totalPage/50' @loadPage="loadChankangLabelList" />
		</div>
	</div>
	
	<AddArticleLabelDialog :show='showAddDialog' :hasRecommend='false' :label='editLabel' @cancel='showAddDialog = false' @confirm='editChankangLabel'/>
	<LoadingDialog :show='showLoadingDialog' />
</template>

<script lang="ts">
import { reactive, toRefs, defineComponent, nextTick, onMounted, ref, watch, computed } from 'vue';
import Pagination from '@/components/Pagination.vue';
import AddArticleLabelDialog from '@/modals/AddArticleLabelDialog.vue';
import LoadingDialog from '@/modals/LoadingDialog.vue';
import request from "@/global";
import { checkResponseDataAndAlert, dateFtt } from '@/common/util';

export default({
	components: { Pagination, AddArticleLabelDialog, LoadingDialog },
	setup() {
		const refData = reactive({
			showAddDialog: false,
			showLoadingDialog: false,
			keywords: "搜索",
			editLabel: {},
		});
		
		const totalPage = ref<number>(0);
		const nowPage = ref<number>(1);
		const dataList = ref<any[]>([]);
		
		//needed in case we switch in from another window
		onMounted(async () => {
		  await loadChankangLabelList(1);
		});
		
		// ========================文章标签========================
		// 添加标签
		const openAddLabelDialog = () => {
			refData.editLabel = { recommend: false, show: true };
			refData.showAddDialog = true;
		};
		
		// 编辑信息
		const openEditLabelDialog = async (card_no: string) => {
		    const errMsg = "查询信息失败";
			try {
				const data = (await request({url: `chankang/label/${card_no}`, get: true})).data;
		        if (checkResponseDataAndAlert(data, errMsg) && data.data) {
					data.data.show = (data.data.show === 1)
					refData.editLabel = data.data;
					refData.showAddDialog = true;
		        }
			} catch (e) {
				console.log(e);
				checkResponseDataAndAlert({}, errMsg);
			}
		}
		
		// 编辑
		const editChankangLabel = async (postObj: any) =>  {
			console.log(postObj);
		    const errMsg = `操作失败`;		
		    if (!postObj.title || postObj.title.length < 1) {
		        alert("请填写标题");
		        return;
		    }
		
		    refData.showLoadingDialog = true;
			try {
				const data = (await request({url: `chankang/label/save`, data: postObj})).data;
				refData.showLoadingDialog = false;
				console.log(data)
		        if (checkResponseDataAndAlert(data, errMsg)) {
					refData.showAddDialog = false;
		            loadChankangLabelList(nowPage.value);
		        }
			} catch (e) {
				console.log(e)
				refData.showLoadingDialog = false;
				checkResponseDataAndAlert({}, errMsg);
			}
		}
		
		// 删除
		const deleteLabel = async (card_no: string, name: string) => {
			if (confirm(`确认删除 ${name} 吗？`)) {
				const errMsg = "删除失败";
				try {
					const data = (await request({url: `chankang/label/delete/${card_no}`, get: true})).data;
					if (checkResponseDataAndAlert(data, errMsg)) {
						alert("删除成功");
						loadChankangLabelList(nowPage.value);
					}
				} catch (e) {
					checkResponseDataAndAlert({}, errMsg);
				}
			}
		};
			
		// 加载列表
		const  loadChankangLabelList = async (page: number) => {
		    if (page < 1) return;
		
		    nowPage.value = page;
			try {
				const data = (await request({url: `chankang/label/list/${page}/${50}?show=2`, get: true})).data;
				if (checkResponseDataAndAlert(data) && data.data) {
				    dataList.value = data.data;
					totalPage.value = data.total;
				}
			} catch (e) {
				checkResponseDataAndAlert({});
			}
		};
		
		const dataRef = toRefs(refData);
		return {
			dataList,
			nowPage,
			totalPage,
			
			dateFtt,
			editChankangLabel,
			loadChankangLabelList,
			openAddLabelDialog,
			openEditLabelDialog,
			deleteLabel,
			
			...dataRef
		};
	},
});
</script>

<style>
</style>
